import React from 'react';
import { Body, Box, Button, Heading, Container } from '@hover/blueprint';
import { Link } from 'gatsby';
import { TrustedByNamesSlide } from '../../common';

const FitIntoYourBusiness: React.FC = () => (
  <Box
    w="100%"
    d={{ base: 'none', tablet: 'flex', desktop: 'none' }}
    flexDir="column"
    alignItems="center"
    pb={800}
    pt={1100}
  >
    <Container px={200} flexDir="column" alingItems="center" maxW="3xl">
      <Heading size={{ base: 500, tablet: 600 }} textAlign="center">
        We fit into your business, not the other way around
      </Heading>
      <Heading size={200} isDisplay textAlign="center" marginBottom={800}>
        HOVER integrates with your favorite tools, so you can share measurements
        and estimates and track jobs across a variety of platforms. It
        shouldn&apos;t be hard to make things easier.
      </Heading>
    </Container>
    <Box mt={800} w="725px" h="480px">
      <TrustedByNamesSlide />
    </Box>
    <Button
      mt={700}
      as={Link}
      size="large"
      w="auto"
      to={`${process.env.GATSBY_V2_PREFIX}/partners`}
    >
      <Body letterSpacng="1px" color="neutral.0" size={300} isBold>
        PARTNERS AND INTEGRATIONS
      </Body>
    </Button>
  </Box>
);

export default FitIntoYourBusiness;
